import { atom, createStore } from 'jotai';

export const jotaiStore = createStore();

export const isOneTrustLoadedAtom = atom<boolean>(false);
export const hydratedOneTrustActiveGroupsAtom = atom<string | undefined>(undefined);
